import React from 'react';
import TitleHeader from 'features/shared/ui/TitleHeader';
import Logout from 'features/shared/Logout';
import { LogoutWrapper, HeaderLink } from './styled';
import HeaderTemplate from 'features/shared/layouts/shared/HeaderTemplate';

import { Space } from '@gr-monorepo/common/ui';
import { useClickStreamContext } from 'features/shared/ClickStream';
const scrollToTop = () => window.scroll(0, 0);
const Header = () => {
  const context = useClickStreamContext();
  return (
    <HeaderTemplate>
      <TitleHeader />
      <Space />
      <LogoutWrapper>
        <Logout />
      </LogoutWrapper>
    </HeaderTemplate>
  );
};

export default Header;
